import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";
import { ADD_REASON_FOR_LEAVING_REQUEST } from "../types";

const addReasonForLeaving = name => async (
  dispatch,
  getState,
  { api, schema }
) => {
  const response = await api.factoring.addReasonForLeaving(name);
  const data = normalize([response], [schema.reasonForLeaving]);
  dispatch(addEntities(data.entities));
  dispatch(
    createAction(ADD_REASON_FOR_LEAVING_REQUEST)({
      items: data.result
    })
  );
  return response;
};

export default addReasonForLeaving;
